import { Component } from "@angular/core";
import { AbstractModal } from "src/app/shared/components/modal/abstractModal";

@Component({
    templateUrl: "./details.overview.html",
    standalone: false,
})
export class CommonGridDetailsExternalLimitationOverviewComponent extends AbstractModal { }
